module.exports = __webpack_public_path__ + "static/media/Statua_031.673da3fd.jpg";